import * as React from "react"
import { ToggleButtonSeeker } from "@ui-seeker/core"

import { GROUPED_BY } from "@constants"
import { typeTab } from "../@signals"


const GROUPED_TABS = [
    { value: GROUPED_BY.VIDEO_CONTENT, label: 'Video content' },
    { value: GROUPED_BY.USER_MANUAL, label: 'User manual' }
]

export default function InfoGroupedByToggleButton() {

    return <ToggleButtonSeeker
        value={typeTab.value ? GROUPED_BY.VIDEO_CONTENT : GROUPED_BY.USER_MANUAL}
        tabs={GROUPED_TABS}
        buttonProps={{sx: { px: 2, fontWeight: 300, "&.Mui-selected, &.Mui-selected:hover": { borderColor: '#6aa8dc !important', fontWeight: 400 } } }}
        onChange={(_, newValue) => typeTab.value = newValue === GROUPED_BY.VIDEO_CONTENT}
    />
}